/*
 * @Author: huangyi
 * @Date: 2024-03-25 14:20:53
 * @LastEditors: huangyi
 * @LastEditTime: 2024-03-25 16:24:14
 * @Description: 埋点指令
 */
import Vue from 'vue'
Vue.directive('tracking', {
    bind(el, binding, vnode) {
        const { context } = vnode
        el.addEventListener('click', () => {
            binding?.value?.event && context.$store?.getters['user/token']&&context.$store.dispatch('tracking/PointList', binding.value)
        })
    }
})
